import { cn } from '@/lib/utils';
import * as React from 'react';

interface TableResizeHandleProps {
  onMouseDown: (event: React.MouseEvent<HTMLDivElement>) => void;
  onTouchStart: (event: React.TouchEvent<HTMLDivElement>) => void;
}

export function TableResizeHandle({ onMouseDown, onTouchStart }: TableResizeHandleProps) {
  return (
    <div
      onMouseDown={onMouseDown}
      onTouchStart={onTouchStart}
      className={cn(
        // Wide invisible draggable area (24px)
        'absolute right-0 top-0 h-full w-2',
        // Center it over the boundary between columns
        'transform -translate-x-1/2',
        'cursor-col-resize select-none touch-none'
      )}
    >
      {/* Thin visible indicator that shows on hover */}
      <div
        className={cn(
          'absolute right-1/2 top-0 h-full w-1',
          'bg-border/40 opacity-0 group-hover:opacity-100',
          'transition-all duration-200'
        )}
      />
    </div>
  );
}
